import template from './location_not_associated.html';
import controller from './location_not_associated.controller';
import './location_not_associated.scss';

let LocationNotAssociatedComponent = {
  restrict: 'E',
  template,
  controller
};

export default LocationNotAssociatedComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/location_not_associated/location_not_associated.component.js